<template>
  <div class="list">
    <p>{{title}}</p>
    <input :class="{error: errors[name].hasError, saved: this.savedFields.hasOwnProperty(this.name) && !changed}" type="text" v-model="item[name]" @blur="isEmpty()"
           @focus="$emit('focus')" @keydown="removeError">
    <div class="invalid_text" v-if="errors[name].hasError">{{errors[name].message}}</div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from 'vuex'

  const {mapMutations, mapState} = createNamespacedHelpers('editPage')
  export default {
    props: ['title', 'name', 'onChanged'],
    data() {
      return {
        changed: false
      }
    },
    watch: {
      onChanged() {
        this.changed = true
      }
    },
    computed: {
      ...mapState([
        'item',
        'errors',
        'savedFields'
      ]),
    },
    methods: {
      ...mapMutations([
        'setError'
      ]),
      isEmpty () {
        if (!this.item[this.name] && !this.errors[this.name].isNullable) {
          this.setError({fieldId: this.name, flag: true})
        }
      },
      removeError () {
        this.changed = true
        if (this.item[this.name]) this.setError({fieldId: this.name, flag: false})
      }
    },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/edit-form/new-items/Input.vue